import { render, staticRenderFns } from "./IconChevronLeft.vue?vue&type=template&id=1b849cc0&scoped=true&"
import script from "./IconChevronLeft.vue?vue&type=script&lang=ts&"
export * from "./IconChevronLeft.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b849cc0",
  null
  
)

export default component.exports